import { useState, useEffect } from "react";
import { MdLogout, MdSettings } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import { FaCar } from "react-icons/fa6";

function SettingsPage({ savedHost, onAddCar, onShowCars, onServerSettings, onLogout }) {
  const [healthStatus, setHealthStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkHealth = async () => {
      try {
        const response = await fetch(`${savedHost}/api/health`, {
          credentials: "include",
        });
        const data = await response.json();
        setHealthStatus(data);
        setLoading(false);
      } catch (error) {
        setHealthStatus({ status: "error", mongo: false, storage: false });
        setLoading(false);
      }
    };

    checkHealth();
    const interval = setInterval(checkHealth, 30000);

    return () => clearInterval(interval);
  }, [savedHost]);

  return (
    <div className="settings-container">
      {/* Health Check Section */}
      <div className="health-check-container">
        <h3 className="health-check-title">Backend Status</h3>
        {loading ? (
          <p className="health-check-loading">Überprüfe...</p>
        ) : (
          <div className="health-check-details">
            <div
              className={`health-status ${
                healthStatus?.status === "ok" ? "health-ok" : "health-error"
              }`}
            >
              <span className="health-label">Status:</span>
              <span className="health-value">
                {healthStatus?.status || "unknown"}
              </span>
            </div>

            {healthStatus?.storage !== undefined && (
              <div
                className={`health-status ${
                  healthStatus?.storage ? "health-ok" : "health-error"
                }`}
              >
                <span className="health-label">Storage:</span>
                <span className="health-value">
                  {healthStatus?.storage ? "✓ Available" : "✗ Unavailable"}
                </span>
              </div>
            )}

            {healthStatus?.uptimeSeconds !== undefined && (
              <div className="health-status health-ok">
                <span className="health-label">Uptime:</span>
                <span className="health-value">
                  {Math.floor(healthStatus.uptimeSeconds / 60)} min
                </span>
              </div>
            )}
          </div>
        )}
      </div>

      {/* 2×2 Grid */}
      <div
        className="settings-menu-grid"
        style={{ gridTemplateColumns: "repeat(2, 1fr)" }}
      >
        {/* Top-left: Fahrzeuge */}
        <div className="settings-menu-item" onClick={onShowCars}>
          <div className="settings-menu-icon">
            <FaCar style={{ color: "white", fontSize: "4rem", width: "3rem" }} />
          </div>
          <h3 className="settings-menu-title">Vorhandene Fahrzeuge</h3>
          <p className="settings-menu-description">
            Alle gespeicherten Fahrzeuge anzeigen und verwalten
          </p>
        </div>

        {/* Top-right: Server-Einstellungen */}
        <div className="settings-menu-item" onClick={onServerSettings}>
          <div className="settings-menu-icon">
            <MdSettings style={{ color: "white", fontSize: "4rem", width: "3rem" }} />
          </div>
          <h3 className="settings-menu-title">Einstellungen</h3>
          <p className="settings-menu-description">
            Servereinstellungen konfigurieren
          </p>
        </div>

        {/* Bottom-left: Fahrzeug hinzufügen */}
        <div className="settings-menu-item" onClick={onAddCar}>
          <div className="settings-menu-icon">
            <IoMdAdd style={{ color: "white", fontSize: "4rem", width: "8rem" }} />
          </div>
          <h3 className="settings-menu-title">Fahrzeugtemplate erstellen</h3>
          <p className="settings-menu-description">
            Füge einer Malvorlage die passenden Aruco-Marker hinzu
          </p>
        </div>

        {/* Bottom-right: Abmelden */}
        <div className="settings-menu-item" onClick={onLogout}>
          <div className="settings-menu-icon">
            <MdLogout style={{ color: "white", fontSize: "4rem", width: "3rem" }} />
          </div>
          <h3 className="settings-menu-title">Abmelden</h3>
          <p className="settings-menu-description">Aus dem System abmelden</p>
        </div>
      </div>
    </div>
  );
}

export default SettingsPage;
